import { render, staticRenderFns } from "./PrivateFileDownload.vue?vue&type=template&id=768a555e&"
import script from "./PrivateFileDownload.vue?vue&type=script&lang=js&"
export * from "./PrivateFileDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports